function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import CustomerCareKeys from '../../../../locales/keys';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import moment from 'moment';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { subscriberProductExpirationRenewOptInOut } from '../../../customer/dashboard/dbssDashboard/dbss.dashboard.actions';
import { AUTO_RENEW_ACTION_TYPES, AUTO_RENEW_ENTITY_TYPES, BILLER_RULE_INSTANCE_TYPE } from '../../../../customercare.constants';
var AutoRenewLinkComponent = /*#__PURE__*/function () {
  function AutoRenewLinkComponent($ngRedux, $timeout, $state, uiNotificationService) {
    _classCallCheck(this, AutoRenewLinkComponent);
    Object.assign(this, {
      $filter: getFilterService(),
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      autoRenewAction: null,
      autoRenewEntity: null,
      autoRenewKeys: CustomerCareKeys.AUTO_RENEW,
      currencyCode: null,
      CustomerCareKeys: CustomerCareKeys,
      formatVariables: this.formatVariables.bind(this),
      hideLabel: false,
      isDisableAutoRenewModalOpen: false,
      isModalOpen: false,
      isOneTimeOffer: false,
      isProduct: false,
      modalApi: null,
      modalConfiguration: null,
      onCloseAutoRenew: this.onCloseAutoRenew.bind(this),
      onCloseDisableAutoRenew: this.onCloseDisableAutoRenew.bind(this),
      onSubmitAutoRenew: this.onSubmitAutoRenew.bind(this),
      onSubmitDisableAutoRenew: this.onSubmitDisableAutoRenew.bind(this),
      onModalOpen: this.onModalOpen.bind(this),
      optIn: null,
      option: null,
      uiNotificationService: uiNotificationService
    });
    this.compareAutoRenewFieldsEquality = function (fieldName, current, prev) {
      return current && prev && current[fieldName] && prev[fieldName] && current[fieldName] !== prev[fieldName];
    };
  }
  return _createClass(AutoRenewLinkComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store)
        };
      };
      var controllerActions = {
        subscriberProductExpirationRenewOptInOut: subscriberProductExpirationRenewOptInOut
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.modalConfiguration = {
        onRegisterApi: function onRegisterApi(event) {
          _this.modalApi = event.api;
        }
      };
    }
  }, {
    key: "onModalOpen",
    value: function onModalOpen(optIn) {
      this.optIn = optIn;
      this.isDisableAutoRenewModalOpen = true;
      if (this.optIn) {
        this.autoRenewAction = AUTO_RENEW_ACTION_TYPES.ENABLE;
        this.autoRenewEntity = AUTO_RENEW_ENTITY_TYPES.PRICING_PLAN;
      } else {
        this.autoRenewAction = AUTO_RENEW_ACTION_TYPES.DISABLE;
        this.autoRenewEntity = AUTO_RENEW_ENTITY_TYPES.PRICING_PLAN;
      }
    }
  }, {
    key: "onCloseAutoRenew",
    value: function onCloseAutoRenew() {
      var _this2 = this;
      this.isModalOpen = false;
      this.$timeout(function () {
        _this2.modalApi.close();
      });
    }
  }, {
    key: "onSubmitAutoRenew",
    value: function onSubmitAutoRenew(values) {
      var _this3 = this;
      if (values) {
        var ReasonCode = values && values.AutoRenewForm && values.AutoRenewForm.ReasonCode;
        this.actions.subscriberProductExpirationRenewOptInOut(this.state.currentCustomerId, this.data.productId, this.optIn, ReasonCode).then(function () {
          _this3.refreshOfferDetails && _this3.refreshOfferDetails();
        });
      }
      this.onCloseAutoRenew();
    }
  }, {
    key: "onCloseDisableAutoRenew",
    value: function onCloseDisableAutoRenew() {
      this.isDisableAutoRenewModalOpen = false;
    }
  }, {
    key: "onSubmitDisableAutoRenew",
    value: function onSubmitDisableAutoRenew(_data, message) {
      this.uiNotificationService.transientSuccess(message);
      this.isDisableAutoRenewModalOpen = false;
      this.refreshOfferDetails && this.refreshOfferDetails();
    }
  }, {
    key: "collectInformation",
    value: function collectInformation() {
      var _this$option = this.option,
        SubscriberProductExpiration = _this$option.SubscriberProductExpiration,
        LockerItemId = _this$option.LockerItemId;
      if (SubscriberProductExpiration) {
        var CanOptIn = SubscriberProductExpiration.CanOptIn,
          CanOptOut = SubscriberProductExpiration.CanOptOut,
          ExpiryDate = SubscriberProductExpiration.ExpiryDate,
          NextExpiryDate = SubscriberProductExpiration.NextExpiryDate,
          SubscriberProductId = SubscriberProductExpiration.SubscriberProductId;
        if (LockerItemId) {
          /** In case of standalone/product order we display we get Product and Pricing Plan Details in same object from /SubscriberManagement/RetrieveConvergentBillerAccountDetails call */
          var _this$option2 = this.option,
            Product = _this$option2.Product,
            Totals = _this$option2.Totals,
            PricingPlan = _this$option2.PricingPlan;
          this.formatVariables(CanOptIn, CanOptOut, true, ExpiryDate || NextExpiryDate, Product.Name, SubscriberProductId, Totals.Sum, PricingPlan.DisplayName);
          this.formatLabel(ExpiryDate, !!NextExpiryDate);
        } else {
          var _this$option3 = this.option,
            PlanName = _this$option3.PlanName,
            BillerTypeAmounts = _this$option3.BillerTypeAmounts,
            ProductClassification = _this$option3.ProductClassification;
          var billerTypeAmounts = BillerTypeAmounts.find(function (billerTypeAmount) {
            return billerTypeAmount.Status === BRI_ACTIVATION_STATUS.ACTIVE && (billerTypeAmount === null || billerTypeAmount === void 0 ? void 0 : billerTypeAmount.Type) === BILLER_RULE_INSTANCE_TYPE.RECURRING;
          });
          var notOneTime = ProductClassification === PRODUCT_CLASSIFICATIONS.PRODUCT ? !this.isOneTimeOffer : true;
          this.formatVariables(CanOptIn && notOneTime, CanOptOut && notOneTime, true, ExpiryDate || NextExpiryDate, PlanName, SubscriberProductId, (billerTypeAmounts === null || billerTypeAmounts === void 0 ? void 0 : billerTypeAmounts.TotalAmount) || (billerTypeAmounts === null || billerTypeAmounts === void 0 ? void 0 : billerTypeAmounts.Amount));
          this.formatLabel(ExpiryDate, !!NextExpiryDate);
        }
      }
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(_dateForLabel, isRenewal) {
      var dateForLabel = moment.utc(_dateForLabel).local();
      if (this.data.showOptIn === undefined && this.data.showOptOut === undefined) {
        this.data.label = i18n.translate(this.autoRenewKeys.PRODUCT_EXPIRATION, {
          date: this.$filter('localShort')(dateForLabel)
        });
      } else {
        this.data.label = i18n.translate(isRenewal ? this.autoRenewKeys.PRODUCT_RENEWAL : this.autoRenewKeys.PRODUCT_EXPIRATION, {
          date: this.$filter('localShort')(dateForLabel)
        });
      }
    }
  }, {
    key: "formatVariables",
    value: function formatVariables(canOptIn, canOptOut, isRenewable, expirationDate, name, id, amount, pricingPlanName) {
      this.data = {};
      this.planDetails = {};
      this.data.counter = 0;
      this.data.showOptIn = canOptIn && isRenewable;
      this.data.showOptOut = canOptOut && isRenewable;
      this.data.expirationDate = expirationDate;
      this.data.productId = id;
      this.data.productName = name;
      this.data.renewalAmount = amount;
      this.data.title = this.data.showOptIn ? CustomerCareKeys.AUTO_RENEW.ENABLE : CustomerCareKeys.AUTO_RENEW.DISABLE;
      this.planDetails = {
        name: pricingPlanName !== null && pricingPlanName !== void 0 ? pricingPlanName : name,
        expirationDate: expirationDate,
        renewalAmount: amount
      };
      /** In case of product order we do not have offer details */
      if (!this.offerDetails) {
        this.offerDetails = {
          DisplayName: name,
          TotalAmount: amount
        };
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _changes$option, _changes$option2, _changes$option3;
      var _ref = ((_changes$option = changes.option) === null || _changes$option === void 0 ? void 0 : _changes$option.currentValue) || {},
        currentSubscriberProductExpiration = _ref.SubscriberProductExpiration;
      var _ref2 = ((_changes$option2 = changes.option) === null || _changes$option2 === void 0 ? void 0 : _changes$option2.previousValue) || {},
        previousSubscriberProductExpiration = _ref2.SubscriberProductExpiration;
      if ((_changes$option3 = changes.option) !== null && _changes$option3 !== void 0 && _changes$option3.isFirstChange() || currentSubscriberProductExpiration !== previousSubscriberProductExpiration || this.compareAutoRenewFieldsEquality('CanOptIn', currentSubscriberProductExpiration, previousSubscriberProductExpiration) || this.compareAutoRenewFieldsEquality('CanOptOut', currentSubscriberProductExpiration, previousSubscriberProductExpiration) || this.compareAutoRenewFieldsEquality('ExpiryDate', currentSubscriberProductExpiration, previousSubscriberProductExpiration) || this.compareAutoRenewFieldsEquality('NextExpiryDate', currentSubscriberProductExpiration, previousSubscriberProductExpiration) || this.compareAutoRenewFieldsEquality('RenewalDisabled', currentSubscriberProductExpiration, previousSubscriberProductExpiration)) {
        this.collectInformation();
      }
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    isOneTimeOffer: '<',
    option: '<',
    refreshOfferDetails: '&?',
    subscriberProductExpiration: '<',
    offerDetails: '<?'
  },
  controller: AutoRenewLinkComponent,
  template: require('./auto.renew.link.template.html')
};